export const environment = {
  production: false,
  apiurl: 'https://devlmsgw.vemoit.com/dae/api/v1.0',
  apiUrlCo: 'https://devlmsgw.vemoit.com/dae-co/api/v2.0',
  recaptcha: {
    siteKey: '6LftH7AjAAAAAM38pDh2MxCYzZgzUikfb1Upkf6O',
  },
  apiurluber: 'https://devlmsgw.vemoit.com/dae/uber/login',
  apiurluberLto: 'https://devlmsgw.vemoit.com/lto/uber/login',
  apiurlOld: 'https://devapifront.vemoit.com',
  apiUrlResume: 'https://devlmsgw.vemoit.com/resume/api/v1.0',
  apiUrlResumeTruora: 'https://devlmsgw.vemoit.com/resume/api/v1.0',
  apiUrlLto: 'https://devlmsgw.vemoit.com/lto/api/v2.0',
  apiUrlVerification: 'https://devlmsgw.vemoit.com',
  apiUrlLink: 'https://devlink.vemoit.com',
  apiUrlLtoV3: 'https://devlmsgw.vemoit.com/lto/api/v3.0',
  DAE_LEGACY_FORM_MODE: 50,
  CAMPAIGNS_FOR_LEGACY_FORM: ['6d081df9-5188-44ed-a67b-7f27a6de1480']
};
